import { useEffect } from "react";
import MapStore from "../Store/MapStore";
import withStore from "../../../Components/Unstated/withStore";

const Markers = ({ markers, mapStore: { setMarkers } }) => {
  const markersString = JSON.stringify(markers);

  useEffect(() => {
    setMarkers(JSON.parse(markersString));
  }, [setMarkers, markersString]);

  return null;
};

export default withStore([MapStore])(Markers);
